import { Search } from 'lucide-react';
import { Input } from './ui/input';

export const HeroSection = ({ searchQuery, setSearchQuery }) => {
  return (
    <div 
      className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1591788114109-c391b0cfdd2f?w=1920&q=80)'
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 hero-overlay" />
      
      {/* Content */}
      <div className="relative z-10 text-center px-4 w-full max-w-3xl">
        <h1 
          className="text-5xl md:text-7xl font-extrabold text-white uppercase italic tracking-tight mb-2"
          style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
        >
          Calendário 2026
        </h1>
        <p className="text-lg md:text-xl text-white/80 mb-8 font-medium">
          Encontra a tua próxima corrida em Portugal
        </p>
        
        {/* Search Bar */}
        <div className="relative max-w-xl mx-auto">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={20} />
          <Input
            type="text"
            placeholder="Pesquisar provas..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-12 pr-4 py-6 text-lg rounded-full bg-white/95 backdrop-blur border-0 shadow-lg focus:ring-2 focus:ring-red-600"
            data-testid="search-input"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
